<template>
  <div class="col-6" id="left-side"></div>
</template>

<script>
import GooglePlacesApi from '../../../../lib/googlePlacesApi.js'
import router from '../../../../router/index.js'
import S3 from 'aws-sdk/clients/s3'
import mixins from '../../Mixins.js'
import MarkerClusterer from '@google/markerclustererplus'

// Setup variables for quick reference
const defaultIcon = {
  url: '../../../../../static/MapMarker.Red.svg',
  scaledSize: new window.google.maps.Size(44, 26)
}
const mousedOverIcon = {
  url: '../../../../../static/MapMarker.Blue.svg',
  scaledSize: new window.google.maps.Size(44, 26)
}
const offMarketIcon = {
  url: '../../../../../static/MapMarker.Gray.svg',
  scaledSize: new window.google.maps.Size(44, 26)
}
const openHouseIcon = {
  url: '../../../../../static/MapMarker.Green.svg',
  scaledSize: new window.google.maps.Size(44, 26)
}
const pendingIcon = {
  url: '../../../../../static/MapMarker.Black.svg',
  scaledSize: new window.google.maps.Size(44, 26)
}
const rentalIcon = {
  url: '../../../../../static/MapMarker.Purple.svg',
  scaledSize: new window.google.maps.Size(44, 26)
}
const pendingConditions = ['Pending', 'Contingent']

export default {
  data () {
    return {
      map: null,
      markers: null,
      markerCluster: null,
      seenAddresses: {}
    }
  },
  mixins: [mixins],
  props: {
    houseData: Array
  },
  async mounted () {
    window.addEventListener('resize', this.setMapWrapperHeight)
    this.initMap()
  },
  computed: {
    searchString () {
      return this.$route.query.search
    }
  },
  methods: {
    async initMap () {
      var latlong = await GooglePlacesApi.zipToLatLong(this.searchString + 'minnesota')
      this.map = new window.google.maps.Map(document.getElementById('left-side'), {
        mapTypeControlOptions: {
          mapTypeIds: [window.google.maps.MapTypeId.ROADMAP]
        },
        center: latlong,
        zoom: 10,
        fullscreenControl: false,
        streetViewControl: false,
        styles: this.mapStyle
      })
      this.createMarkers()
    },
    createContentString (data) {
      var s3 = new S3()

      var photoArray = data._source.photos ? data._source.photos[0].split('/') : ['', '']
      photoArray.shift()
      var photoKey = 'small/' + photoArray.join('/')
      var params = {
        Bucket: window.CONFIG.MLSPhotoBucketName,
        Key: photoKey
      }
      let signedURL = data._source.photos ? s3.getSignedUrl('getObject', params) : '../../../../../static/NoPhotoAvailable.Yellow.svg'
      let listPrice = data._source.price ? '$' + data._source.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
      let bathsFull = data._source.bathroom_count ? data._source.bathroom_count : ''
      let bedrooms = data._source.bedroom_count ? data._source.bedroom_count : ''
      let stringSqft = data._source.house_sqft ? data._source.house_sqft.toString() : ''
      let sqft = stringSqft ? stringSqft.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'ft²' : ''
      let formatSpacing = 75
      if (stringSqft && stringSqft.length < 4) {
        formatSpacing = 32
      } else if (stringSqft && stringSqft.length === 4) {
        formatSpacing = 28
      } else if (stringSqft && stringSqft.length > 4) {
        formatSpacing = 30
      }
      let textSize = stringSqft.length > 4 ? 0.9 : 1
      var contentString = `
        <div class="container">
          <div style="position: relative;">
            <img src=${signedURL} alt="Home Photo" style="width: 100%;">
            <h5 style="position: absolute; bottom: 1.5rem; left: 0.5rem; font-family: Impact; font-size: 1.5rem; font-weight: 900; color: white !important; -webkit-text-stroke-width: 1px; -webkit-text-stroke-color: black;">${listPrice}</h5>
            <h6 style="position: absolute; bottom: 0rem; left: 0.5rem; font-family: Impact; font-size: ${textSize}rem; font-weight: 900; color: white !important; -webkit-text-stroke-width: 1px; -webkit-text-stroke-color: black;">${bedrooms} <i class="fas fa-bed"></i></h6>
            <h6 style="position: absolute; bottom: 0rem; left: ${formatSpacing}%; font-family: Impact; font-size: ${textSize}rem; font-weight: 900; color: white !important; -webkit-text-stroke-width: 1px; -webkit-text-stroke-color: black;">${bathsFull} <i class="fas fa-bath"></i></h6>
            <h6 style="position: absolute; bottom: 0rem; right: 0.5rem; font-family: Impact; font-size: ${textSize}rem; font-weight: 900; color: white !important; -webkit-text-stroke-width: 1px; -webkit-text-stroke-color: black;">${sqft} <i class="fas fa-ruler-combined"></i></h6>
          </div>
        </div>`
      return contentString
    },
    createMarker (house) {
      let that = this
      let price = house._source.price
      price = this.setPriceString(price)
      let icon = defaultIcon
      if (house._source.special_circumstances && house._source.special_circumstances === 'Rental') icon = rentalIcon
      if (house._source.status && pendingConditions.includes(house._source.status)) icon = pendingIcon
      if (house._source.open_houses) icon = openHouseIcon
      if ((house._source.special_circumstances && house._source.special_circumstances === 'Off Market') || (house._source.status && house._source.status === 'Sold')) icon = offMarketIcon
      var marker = new window.google.maps.Marker({
        position: new window.google.maps.LatLng(Number(house._source.latitude), Number(house._source.longitude)),
        map: this.map,
        icon: icon,
        label: {text: price, color: '#feedaa'}
      })
      marker.addListener('mouseover', function () {
        marker.setIcon(mousedOverIcon)
        var infoWindow = new window.google.maps.InfoWindow({
          content: that.createContentString(house),
          disableAutoPan: true,
          maxWidth: 300
        })
        infoWindow.open(this.map, marker)
        marker.addListener('mouseout', function () {
          infoWindow.close()
          marker.setIcon(icon)
        })
      })
      marker.addListener('click', function () {
        router.push('home/' + house._id + '/' + that.searchString + '/info')
      })
      return marker
    },
    createMultiUnitMarker (addressInfo) {
      let that = this
      let icon = defaultIcon
      var marker = new window.google.maps.Marker({
        position: new window.google.maps.LatLng(Number(addressInfo.latitude), Number(addressInfo.longitude)),
        map: this.map,
        icon: defaultIcon,
        label: {text: (addressInfo.count > 1 ? addressInfo.count.toString() + ' Units' : '1 Unit'), color: '#feedaa', fontSize: '12'}
      })
      marker.addListener('mouseover', function () {
        marker.setIcon(mousedOverIcon)
        var infoWindow = new window.google.maps.InfoWindow({
          content: 'Click to search and view units associated with this address',
          disableAutoPan: true,
          maxWidth: 300
        })
        infoWindow.open(this.map, marker)
        marker.addListener('mouseout', function () {
          infoWindow.close()
          marker.setIcon(icon)
        })
      })
      marker.addListener('click', function () {
        that.$emit('unit-data-requested', addressInfo.addresses)
      })
      return marker
    },
    clearMarkers () {
      for (var id in this.markers) {
        this.markers[id].setMap(null)
      }
      this.markers = {}
      this.seenAddresses = {}
      if (this.markerCluster) this.markerCluster.clearMarkers()
    },
    createMarkers () {
      this.clearMarkers()
      var bounds = new window.google.maps.LatLngBounds()
      for (let i = 0; i < this.houseData.length; i++) {
        let house = this.houseData[i]
        let latLongString = house._source.latitude + ',' + house._source.longitude
        let addressObject = this.createAddressObject(house._source)
        let addressString = this.createAddressString(house._source)
        if (latLongString in this.seenAddresses) {
          this.seenAddresses[latLongString].count += 1
          this.seenAddresses[latLongString].house_ids.push(i)
          if (!(this.seenAddresses[latLongString].addressStrings.includes(addressString))) {
            this.seenAddresses[latLongString].addressStrings.push(addressString)
            this.seenAddresses[latLongString].addresses.push(addressObject)
          }
        } else {
          this.seenAddresses[latLongString] = {count: 1, latitude: house._source.latitude, longitude: house._source.longitude, addressStrings: [addressString], addresses: [addressObject], house_ids: [i]}
        }
      }
      for (let latLong in this.seenAddresses) {
        let currentData = this.seenAddresses[latLong]
        var marker = null
        if (currentData.count > 1) {
          marker = this.createMultiUnitMarker(currentData)
        } else {
          marker = this.createMarker(this.houseData[currentData.house_ids[0]])
        }
        let markerPosition = new window.google.maps.LatLng(marker.position.lat(), marker.position.lng())
        this.markers[latLong] = marker
        bounds.extend(markerPosition)
      }
      this.markerCluster = new MarkerClusterer(this.map, this.markers, {
        minimumClusterSize: 1,
        gridSize: 90, // # the grid size of a cluster in pixels (grid is square)
        maxZoom: 12, // disables clustering after 12 zoom
        averageCenter: true, // places cluster at center of points as opposed to first point within cluster
        title: '', // tooltip to display when the mouse moves over cluster
        zoomOnClick: true,
        calculator: function (markers, numStyles) {
          return {
            title: 'Click to view ' + markers.length + ' homes',
            text: markers.length,
            index: 0
          }
        },
        styles: [
          {
            textColor: 'white',
            url: '../../../../../static/MapClusterIcon.svg',
            height: 25,
            width: 25,
            anchorText: [6, 0]
          }
        ]
      })
      this.map.fitBounds(bounds)
      this.map.panToBounds(bounds)
    },
    createAddressObject (addressObj) {
      let address = {}
      if ('street_number' in addressObj) { address['street_number'] = addressObj['street_number'] }
      if ('street_name' in addressObj) { address['street_name'] = addressObj['street_name'] }
      if ('street_suffix' in addressObj) { address['street_suffix'] = addressObj['street_suffix'] }
      if ('street_dir' in addressObj) { address['street_dir'] = addressObj['street_dir'] }
      if ('city' in addressObj) { address['city'] = addressObj['city'] }
      if ('state' in addressObj) { address['state'] = addressObj['state'] }
      if ('zip_code' in addressObj) { address['zip_code'] = addressObj['zip_code'] }

      return address
    },
    createAddressString (addressObj) {
      let address = ''
      if ('street_number' in addressObj) { address += addressObj['street_number'] + ' ' }
      if ('street_name' in addressObj) { address += addressObj['street_name'] }
      if ('street_suffix' in addressObj) { address += ' ' + addressObj['street_suffix'] }
      if ('street_dir' in addressObj) { address += ' ' + addressObj['street_dir'] }
      if ('city' in addressObj) { address += ', ' + addressObj['city'] }
      if ('state' in addressObj) { address += ', ' + addressObj['state'] }
      if ('zip_code' in addressObj) { address += ', ' + addressObj['zip_code'] }

      return address
    }
  },
  watch: {
    houseData: {
      handler: function () {
        if (this.map !== null) this.createMarkers()
      },
      deep: true
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setMapWrapperHeight)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/homeSearch/leftSide/TheMap.vue